import { BlockWrapper, defineBlock, useEditor } from '@smartfire/js-block-engine';
import style from './style.module.scss';
import clsx from 'clsx';

const SeoFooterBlock = ({ content }) => {
    const { isEditing } = useEditor();

    return isEditing || (content && content.length > 0) ? (
        <BlockWrapper.Section className={clsx(style.block, isEditing ? style.admin : style.frontend)}>
            {content && <div className={style.content} dangerouslySetInnerHTML={{ __html: content }} />}
            {isEditing && <p>SEO Footer</p>}
        </BlockWrapper.Section>
    ) : (
        <BlockWrapper.Section />
    );
};

export default defineBlock({
    Block: SeoFooterBlock,
    setup: {
        title: 'SEO Footer',
    },
});
